import React, { useState, useEffect } from 'react'
import { Table, Form, Radio, Select, Flex, Space, InputNumber, Input, Button } from 'antd';
import { useZzDZZQuery } from '../store/DianShangYeWuApi';
import classes from './bank.module.css';
import IncomeCheck from '../document/income/IncomeCheck';
import CostCheck from '../document/cost/CostCheck';
import ExpenseCheck from '../document/expense/ExpenseCheck';
import LoanCheck from '../document/loan/LoanCheck';
import BankRecordAdd from './BankRecordAdd';
import Icon from '../cpn/Icon';
function BankDocumentList(props) {
    const [form] = Form.useForm();
    const [query, setQuery] = useState({
        'danju_qy_id': props.qy_id,
        'danju_type_name': '',
        'danju_bm_id': ''
    });
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState([]);
    const [selectedRowAmount, setSelectedRowAmount] = useState([]);
    const [selectedRowTypeNames, setSelectedRowTypeNames] = useState([]);
    const [selectedRowZFLXs, setSelectedRowZFLXs] = useState([]);
    const [list, setList] = useState([]);
    const {data, isSuccess,refetch} = useZzDZZQuery({'danju_qy_id': props.qy_id},{refetchOnMountOrArgChange:1});
    useEffect(() => {
        if (isSuccess && data && Array.isArray(data.Result)) {
            let arr = data.Result.filter(item => {
                if(item.danju_zflx && item.danju_kh_name && item.danju_type_name ==='借款单'){
                    return true;
                }else if(item.danju_zflx && item.danju_kh_name && item.danju_type_name !=='借款单' && item.danju_zflx !== '应收' && item.danju_zflx !== '应付'){
                    return true;
                }else{
                    return false;
                }
            });
            if(query.danju_type_name){
                arr = arr.filter(item => item.danju_type_name === query.danju_type_name);
            }
            if(query.danju_amount){
                arr = arr.filter(item => Number(item.danju_amount) === Number(query.danju_amount));
            }
            if(query.danju_id){
                arr = arr.filter(item => item.danju_id === query.danju_id);
            }
            setList(arr);
        }
    }, [data, isSuccess, query.danju_type_name, query.danju_amount, query.danju_id])
    

    const columns = [        
        // {
        //     title: '操作',
        //     dataIndex: 'action',
        //     key: 'action',
        //     render: (text, record) => <BankRecordAdd 
        //                                     bankAccountList={props.bankAccountList} 
        //                                     danju_kh_name={record.danju_kh_name} 
        //                                     danju_zflx={record.danju_zflx} 
        //                                     danju_amount={record.danju_amount}
        //                                     danju_type_name={record.danju_type_name}
        //                                     danju_id={record.danju_id}
        //                                     qy_id={props.qy_id}
        //                                     qy_name={props.qy_name}
        //                                     yh_id={props.yh_id}
        //                                     yh_name={props.yh_name}
        //                                     yh_qx={props.yh_qx}
        //                                     refetch={refetch}
        //                                 />
        // },
        {
            title: '单据金额',
            dataIndex: 'danju_amount',
            key: 'danju_amount',
            render: (text, record) => {
               if((record.danju_type_name === '收款单' && (record.danju_zflx === '现收' || record.danju_zflx === '核销应收'))){
                return <span style={{color:'red'}}>￥{Number(text).toLocaleString('zh-CN', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}</span>
               }else if((record.danju_type_name === '付款单' && (record.danju_zflx === '现付' || record.danju_zflx === '核销应付')) || (record.danju_type_name === '费用单' && (record.danju_zflx === '现付')) || (record.danju_type_name === '借款单')){
                return <span style={{color:'green'}}>￥{Number(text).toLocaleString('zh-CN', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}</span>
               }else{
                return <span>无须记账</span>
               }
            }
        },
        {
            title: '客户',
            dataIndex: 'danju_kh_name',
            key: 'danju_kh_name',
            render: (text, record) => {
                if(record.danju_type_name === '收款单'){
                    return <IncomeCheck ddsr_id={record.danju_id} ddsr_kh_name={record.danju_kh_name}  ddsr_kh_id={record.danju_kh_id} qy_name={record.danju_qy_name} qy_id={record.danju_qy_id} yh_id={record.danju_yh_id} yh_name={record.danju_yh_name}/>
                }else if(record.danju_type_name === '付款单'){
                    return <CostCheck ddzc_id={record.danju_id} ddzc_kh_name={record.danju_kh_name} ddzc_kh_id={record.danju_kh_id} qy_name={record.danju_qy_name} qy_id={record.danju_qy_id} yh_id={record.danju_yh_id} yh_name={record.danju_yh_name}/>
                }else if(record.danju_type_name === '费用单'){
                    return <ExpenseCheck fy_id={record.danju_id} fy_kh_name={record.danju_kh_name} fy_kh_id={record.danju_kh_id} qy_name={record.danju_qy_name} qy_id={record.danju_qy_id} yh_id={record.danju_yh_id} yh_name={record.danju_yh_name}/>
                }else if(record.danju_type_name === '借款单'){
                    return <LoanCheck jk_id={record.danju_id} jk_kh_name={record.danju_kh_name} jk_kh_id={record.danju_kh_id} qy_name={record.danju_qy_name} qy_id={record.danju_qy_id} yh_id={record.danju_yh_id} yh_name={record.danju_yh_name}/>
                }
            },
            width: '14%',
        },
        {
            title: '单据类型',
            dataIndex: 'danju_type_name',
            key: 'danju_type_name',
        },
      
        {
            title: '单据日期',
            dataIndex: 'danju_date',
            key: 'danju_date',
            width: '8%',
        },
       
        {
            title: '往来类型',
            dataIndex: 'danju_zflx',
            key: 'danju_zflx',
            width: '6%',
        },
        {
            title: '单据备注',
            dataIndex: 'danju_content',
            key: 'danju_content',
        },
        {
            title: '单据编号',
            dataIndex: 'danju_id',
            key: 'danju_id',            
        },
      
    ]
    return (
        <>
            <Flex justify='space-between'>
                <Form
                    name='bankDocumentList'
                    form={form}
                    layout='inline'
                >
                    <Form.Item 
                        name='danju_type_name'
                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({...prev, danju_type_name: e.target.value}));
                            }}
                        >
                            <Radio value='收款单'>收款单</Radio>
                            <Radio value='付款单'>付款单</Radio>
                            <Radio value='费用单'>费用单</Radio>
                            <Radio value='借款单'>借款单</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name='danju_amount' wrapperCol={{ offset: 2 }}>
                        <InputNumber
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, danju_amount: value }));
                            }}
                            value={query.danju_amount ? query.danju_amount : undefined}
                            placeholder='单据金额'
                            name='danju_amount'
                            style={{ width: '120px' }}
                        />
                    </Form.Item> 
                    <Form.Item name='danju_bm_id' label='部门'>
                        <Select 
                            options={props.deptList.map(item => ({ label: item.d_name, value: item.d_id }))} 
                            placeholder='请选择部门' 
                            onChange={(value) => {
                                setQuery(prev => ({...prev, danju_bm_id: value}));
                            }}
                        />
                    </Form.Item>
                    <Form.Item name='danju_id' >
                        <Input placeholder='单据编号' onChange={(e) => {setQuery(prev => ({ ...prev, danju_id: e.target.value || '' }))}} style={{ width: "100px" }} />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset' 
                                onClick={() => {
                                    form.resetFields();
                                    setQuery(prev => ({...prev, danju_type_name: '', danju_bm_id: '', danju_amount: '', danju_id: ''}));
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>
                <Space>
                    <span>
                    当前已选择<span style={{fontWeight: 'bold',fontSize: '16px'}}>{selectedRowKeys.length}</span>条<span style={{fontWeight: 'bold',fontSize: '16px'}}>{selectedRowTypeNames[0]}</span>，
                    {selectedRowTypeNames[0] === '收款单' ? '转入' : '转出'}金额
                    <span style={{color: selectedRowTypeNames[0] === '收款单' ? 'red' : 'green',fontWeight: 'bold',fontSize: '16px'}}>￥{selectedRowAmount.reduce((acc, curr) => acc + Number(curr || 0), 0).toLocaleString('zh-CN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}</span>
                    </span>
                    <BankRecordAdd 
                        selectedRowId={selectedRowId}
                        selectedRowAmount={selectedRowAmount}
                        selectedRowTypeNames={selectedRowTypeNames}
                        selectedRowZFLXs={selectedRowZFLXs}
                        bankAccountList={props.bankAccountList} 
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        yh_qx={props.yh_qx}
                        refetch={refetch}
                        onSuccess={() => {
                            setSelectedRowKeys([]);
                            setSelectedRowId([]);
                            setSelectedRowAmount([]);
                            setSelectedRowTypeNames([]);
                            setSelectedRowZFLXs([]);
                        }}
                    />
                    <Button onClick={() => {setSelectedRowKeys([]); setSelectedRowId([]); setSelectedRowAmount([]); setSelectedRowTypeNames([]); setSelectedRowZFLXs([]);}}>重置</Button>
                </Space>
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                bordered
                size='small'
                rowKey={(record) => record.danju_type_name + '_' + record.danju_id}
                className={classes.customTable}
                rowSelection={{
                    selectedRowKeys,
                    type: 'checkbox',
                    // 禁用无须记账的复选框（假设用 needAccount 字段表示是否需要记账，不需要时为 false 或 0）
                    getCheckboxProps: (record) => ({
                        // 这里的 disabled 逻辑只是在复选框上设置禁用，并不会控制选择行的状态或样式。
                        // 要确保生效，还需要保证该字段传递到 Table 的 rowSelection 中，Table 没有缓存旧的 disabled 结果，以及行数据的这几个字段都存在且无误。
                        // 此处逻辑本身没有问题：只有(应收且不是借款单)或应付，才禁用。
                        // 建议检查 Table 组件和 list 数据源是否会更新，或 disabled 字段值计算是否传递了正确的最新 record。
                        disabled: (record.danju_zflx === '应收' && record.danju_type_name !== '借款单') || record.danju_zflx === '应付' || record.danju_zflx === 'null' || record.danju_zflx === '1'|| record.danju_zflx === 'undefined' ,
                    }),
                    // 可以按需添加onChange, selectedRowKeys等参数
                    onChange: (selectedRowKeys, selectedRows) => {
                        // 判断如果选择的单据类型不一致，则报错提示
                        if (
                            selectedRows.length > 0 &&
                            selectedRows.some(item => item.danju_type_name !== selectedRows[0].danju_type_name)
                        ) {
                            window?.['antd']?.message?.error
                                ? window['antd'].message.error('批量记账的单据类型必须相同！')
                                : alert('批量记账的单据类型必须相同！');
                            return;
                        }
                        setSelectedRowId(selectedRows.map(item => item.danju_id));
                        setSelectedRowKeys(selectedRowKeys);
                        setSelectedRowTypeNames(selectedRows.map(item => item.danju_type_name));
                        setSelectedRowZFLXs(selectedRows.map(item => item.danju_zflx));
                        setSelectedRowAmount(selectedRows.map(item => item.danju_amount));
                    }
                }}
                pagination={{
                    pageSize: 100,
                    pageSizeOptions: [100, 200, 500, 1000],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `共 ${total} 条`,
                }}
            />
        </>
    )
}

export default BankDocumentList